import { LoadingSpinner } from './LoadingSpinner'

/**
 * Page loading fallback component for Suspense boundaries during lazy loading.
 * Used as fallback for route-level code splitting.
 *
 * Importing LoadingSpinner here ensures it is included in the main bundle
 * (since PageLoader is eagerly loaded by App.tsx and MainLayout.tsx),
 * preventing Rollup from code-splitting it into a tiny separate chunk.
 */
function PageLoader() {
  return (
    <div
      className="flex items-center justify-center h-full min-h-[200px]"
      role="status"
      aria-label="Loading page"
    >
      <LoadingSpinner text="Loading..." />
    </div>
  )
}

export default PageLoader
